import React from 'react';

const Loading = () => {
    return ( 
        <div className="loading">
            <div className="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
     );
}
 
export default Loading;